import { useState } from "react";
import { useParams } from "react-router-dom";
import FolderActionMenu from "containers/admin/clients/campaign/campaign-creative-page/components/folder-action-menu/folder-action-menu";
import CreativeTable from "containers/admin/clients/campaign/campaign-creative-page/components/creactive-table/creative-table";
import ControlBar from "components/partials/control-bar/control-bar";
import CampaignContextMenu from "containers/admin/clients/campaign/campaign-creative-page/components/campaign-context-menu/campaign-context-menu";
import { Breadcrumbs } from "ui/breadcrumbs";
import { FillHeightPage } from "ui/data-grid";

import Icons from "assets";import { useFolder } from "hooks/api/use-folders";
import { useTouchpoints } from "hooks/api/use-touchpoints";
import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";
import { TouchpointActionProvider } from "../../../contexts/touchpoint-action-context";
import { useCampaignJobPollingContext } from "hooks/campaign-job-polling-provider";
import { getClientPaths, getCampaignPaths } from "utilities/app-routes";

const FolderDetailsContent = () => {
  const { clientId = "", campaignId = "", folderId = "" } = useParams<{ clientId: string; campaignId: string; folderId: string }>();
  const { data: folderDetails } = useFolder(folderId);
  const folderName = folderDetails?.name ?? "";

  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();

  const { clientCampaignsPath } = getClientPaths({ clientId });
  const { campaignCreativePath } = getCampaignPaths({ clientId, campaignId });

  const isMondayFolder = !!folderDetails?.isMondayFolder;

  const { data } = useTouchpoints({ "folderId.in": [folderId] });

  const { startPolling } = useCampaignJobPollingContext();

  const handleSuccess = () => {
    setSelectedIds([]);
    startPolling();
  };

  const selectedTouchpoints = (data?.items ?? []).filter((item) =>
    selectedIds.includes(item.id),
  );
  const totalCreatives = data?.totalElements ?? 0;

  return (
    <TouchpointActionProvider onSuccess={handleSuccess}>
      <FillHeightPage>
        <Breadcrumbs
          breadcrumbs={[
            { label: currentClient?.name ?? "", href: clientCampaignsPath },
            { label: "Campaigns", href: clientCampaignsPath },
            { label: currentCampaign?.name ?? "", href: campaignCreativePath },
            { label: folderName, active: true },
          ]}
        />
        <div className="flex shrink-0 justify-between">
          <div className="flex gap-2 items-center">
            <Icons.Folder className="size-6 text-gray-400" />

            <h1 className="text-2xl font-bold text-navy-800">{folderName}</h1>
          </div>
          <div className="flex items-center gap-2.5">
          <CampaignContextMenu
            totalCreatives={totalCreatives}
            selectedTouchpoints={selectedTouchpoints}
            folderId={folderId}
            newCreativeMenuPage="folder"
            isMondayFolder={isMondayFolder}
          />
            {!selectedIds.length && (
              <ControlBar variant="inset">
                {folderDetails && <FolderActionMenu folder={folderDetails} />}
              </ControlBar>
            )}
          </div>
        </div>
        <CreativeTable
          folderId={folderId}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
        />
      </FillHeightPage>
    </TouchpointActionProvider>
  );
};

export default FolderDetailsContent;
